// Benepack OMS · Breadcrumb · 从 route handle 自动拼装 (sitemap §5)
import { Breadcrumb as AntdBreadcrumb } from 'antd';
import { Link, useMatches } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';

export interface RouteHandle {
  title?: string; // i18n key 或字面量
  titleI18n?: string;
}

export function Breadcrumb() {
  const matches = useMatches();
  const { t } = useTranslation();

  const items = useMemo(() => {
    return matches
      .filter((m) => (m.handle as RouteHandle | undefined)?.title)
      .map((m) => {
        const h = m.handle as RouteHandle;
        const label = h.titleI18n ? t(h.titleI18n) : (h.title ?? '');
        return {
          title:
            m.pathname === window.location.pathname ? label : <Link to={m.pathname}>{label}</Link>,
        };
      });
  }, [matches, t]);

  return <AntdBreadcrumb items={items} />;
}
